function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import SelectableProductCard from "./selectable-product-card/selectable-product-card";
import CarouselTagsComponent from "../carousel-tags/carousel-tags-component";
import { StyledDesktopCarouselTagsComponent } from "./desktop-carousel-tags-component.scss";
import { useNumberOfSlides } from "./useNumberOfSlides";
const DesktopCarouselTagsComponent = (_param)=>{
    var { cards, cardConfig } = _param, rest = _object_without_properties(_param, [
        "cards",
        "cardConfig"
    ]);
    const slidesToShow = useNumberOfSlides(cards.length);
    const itemRenderer = (card)=>/*#__PURE__*/ _jsx(SelectableProductCard, _object_spread_props(_object_spread({}, card), {
            cardPadding: cardConfig === null || cardConfig === void 0 ? void 0 : cardConfig.cardPadding,
            spaceBetweenCardDetails: cardConfig === null || cardConfig === void 0 ? void 0 : cardConfig.spaceBetweenCardDetails,
            spaceBetweenCardContent: cardConfig === null || cardConfig === void 0 ? void 0 : cardConfig.spaceBetweenCardContent,
            cardContentTextColor: cardConfig === null || cardConfig === void 0 ? void 0 : cardConfig.cardContentTextColor,
            cardDetailsProductIconHeight: cardConfig === null || cardConfig === void 0 ? void 0 : cardConfig.cardDetailsProductIconHeight,
            cardContentProductIconHeight: cardConfig === null || cardConfig === void 0 ? void 0 : cardConfig.cardContentProductIconHeight
        }));
    const tagsCarouselProps = {
        itemRenderer,
        slidesToShow
    };
    return /*#__PURE__*/ _jsx(StyledDesktopCarouselTagsComponent, {
        children: /*#__PURE__*/ _jsx(CarouselTagsComponent, _object_spread_props(_object_spread({}, rest), {
            cards: cards,
            tagsCarouselProps: tagsCarouselProps,
            cardHeight: cardConfig === null || cardConfig === void 0 ? void 0 : cardConfig.cardHeight
        }))
    });
};
export default DesktopCarouselTagsComponent;
